import React from 'react';
import { PipelineStatus } from '../../../const/PipelineTypes';
import { getStatusColor } from '../PipelineTableFunctionality';

interface StageIconProps {
  status: PipelineStatus;
  theme: boolean;
  size?: number;
}

const StageIcon: React.FC<StageIconProps> = ({ status, theme, size = 22 }) => {
  const baseStyle = { width: size, height: size, display: 'inline-block' as const, verticalAlign: 'top' as const };
  const iconStyle = { fontSize: size, color: getStatusColor(status, theme), verticalAlign: 'top' as const };

  switch (status) {
    case PipelineStatus.InProgress:
      return <span className="wf-icon-running" style={baseStyle} />;
    case PipelineStatus.Completed:
    case PipelineStatus.Success:
      return <span className="wf-icon-success" style={baseStyle} />;
    case PipelineStatus.Failure:
      return <span className="wf-icon-failed" style={baseStyle} />;
    case PipelineStatus.Canceled:
      return <i className="icon icon-block" style={iconStyle} />;
    case PipelineStatus.Pending:
      return <span className="wf-icon-notstarted" style={baseStyle} />;
    case PipelineStatus.Banned:
      return <i className="icon icon-block" style={iconStyle} />;
    case PipelineStatus.Manual:
      return (
        <span className="round" style={{ width: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-info" style={{ fontSize: size - 4, position: 'relative', left: 2, bottom: 2 }} />
        </span>
      );
    case PipelineStatus.Warning:
      return (
        <span className="round" style={{ width: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-triangle-warning" style={{ fontSize: size - 6, position: 'relative', left: 3, bottom: 2 }} />
        </span>
      );
    case PipelineStatus.Aborted:
      return (
        <span className="round" style={{ width: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-minus-small" style={{ fontSize: size - 6, position: 'relative', left: 3, bottom: 1 }} />
        </span>
      );
    case PipelineStatus.Paused:
      return (
        <span className="round" style={{ width: size, height: size, background: getStatusColor(status, theme) }}>
          <i className="icon icon-video-pause" style={{ fontSize: size - 7, position: 'relative', left: 3.5, bottom: 0.5 }} />
        </span>
      );
    default:
      return <span className="wf-icon-notstarted" style={baseStyle} />;
  }
};

export default StageIcon;
